import PGlobal from './PGlobal';
import PSprite from './PSprite';

export default class StepLine extends PSprite {
    constructor(data) {
        super();

        this.data = data;
        this.background = new PIXI.Graphics();
        this.addChild(this.background);
        this.canvas = new PIXI.particles.ParticleContainer();
        this.addChild(this.canvas);
        this._length = 0;
        this._selected = 0;
        this.fixedW = 0;
        this.fixedH = 0;
        this.isMouseDown = false;
        this.itemW = PGlobal.resources.mainUI.textures["dot_click"].width;

        this.interactive = true;
        this.on('mousedown', (e) => this.onMouseDown(e));
        this.on('mousemove', (e) => this.onMouseMove(e));
        this.on('mouseup', (e) => this.onMouseUp(e));
        this.on('mouseout', (e) => this.onMouseOut(e));

        this.data.on('selectDict', this.dirty, this);
    }

    set length(len) {
        this._length = len;
        this.dirty();
    }

    redraw() {
        this.background.clear();
        this.background.beginFill(0x272727);
        this.background.drawRect(0, 0, this.fixedW, this.fixedH);
        this.background.endFill();
        this.background.beginFill(0x919191);
        this.background.drawRect(0, this.fixedH/2-1, this.fixedW, 2);
        this.background.endFill();

        this.canvas.removeChildren();
        for(let i=0; i < this._length; ++i) {
            let sprite = new PIXI.Sprite();
            if(this.data.selectDict[i]) {
                sprite.texture = PGlobal.resources.mainUI.textures["dot_click"];
            }else if(i == this._length-1) {
                sprite.texture = PGlobal.resources.mainUI.textures["dot_last"];
            }else {
                sprite.texture = PGlobal.resources.mainUI.textures["dot_normal"];
            }
            sprite.x = i*sprite.width;
            sprite.y = 2;
            this.canvas.addChild(sprite);
        }
    }

    onMouseDown(e) {
        let p = e.data.getLocalPosition(this);
        let index = Math.floor(p.x / this.itemW);
        if(index >= 0 && index < this._length && index != this.data.playIndex) {
            this.data.preview(index);
        }
        this.isMouseDown = true;
    }

    onMouseMove(e) {
        if(this.isMouseDown) {
            let p = e.data.getLocalPosition(this);
            let index = Math.floor(p.x / this.itemW);
            if(index >= 0 && index < this._length && index != this.data.playIndex) {
                this.data.preview(index);
            }
        }
    }

    onMouseUp(e) {
        let p = e.data.getLocalPosition(this);
        let index = Math.floor(p.x / this.itemW);
        if(index >= 0 && index < this._length) {
            this.data.play(index);
        }
        this.isMouseDown = false;
    }

    onMouseOut(e) {
        if(this.isMouseDown) {
            let p = e.data.getLocalPosition(this);
            let index = Math.floor(p.x / this.itemW);
            if(index >= 0 && index < this._length) {
                this.data.play(index);
            }
            this.isMouseDown = false;
        }
    }

    resize(w, h) {
        this.fixedW = w;
        this.fixedH = h;
        this.dirty();
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/StepLine.js